/**
 * Унифицированное описание CTA-элементов (кнопок) hero/teaser-блоков.
 *
 * Блок сверху страницы может дёрнуть три типа действий:
 *   1. внутренний переход (через `vue-router`) — `to: RouteLocationRaw`;
 *   2. внешний переход (открыть ссылку) — `href: string`;
 *   3. локальное действие (открыть модалку, проскроллить) — `action`.
 *
 * Чтобы шаблоны не тащили ветвление `v-if isRouter / v-else-if a / else`
 * в каждом hero-блоке, кладём решение в чистую функцию и пользуемся
 * ею в `CtaButton`.
 */
import type { RouteLocationRaw } from 'vue-router';
import type { Cta, CtaKind } from '@/types/types';

export type { CtaAction, Cta, CtaKind } from '@/types/types';

/**
 * Решает, какой тип рендера нужен для данного CTA. Проверки сделаны
 * детерминированно и устойчиво: `action` имеет меньший приоритет, чем
 * явные `to`/`href`, чтобы можно было смешивать их без сюрпризов
 * (`{to:'/brief', action:'scroll-to'}` → `route`).
 */
export function resolveCtaKind(cta: Cta): CtaKind {
  if (cta.to !== undefined && cta.to !== null) {
    return { kind: 'route', to: cta.to as RouteLocationRaw };
  }
  if (typeof cta.href === 'string' && cta.href.length > 0) {
    return { kind: 'external', href: cta.href };
  }
  return { kind: 'action' };
}
